import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://bjrxkfgjhjheypdawhke.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJqcnhrZmdqaGpoZXlwZGF3aGtlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzkzMDE3NDIsImV4cCI6MjA5NDg3Nzc0Mn0.EgyXE1of_2O54rdfi0HPmskVYmRmRBW2y6p_QwJx8OU'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
